import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaDog, FaHandHoldingUsd, FaCalendarCheck, FaHome } from "react-icons/fa";
import "./TimelineSection.css";

const steps = [
  {
    icon: <FaDog />,
    title: "Find Your New Best Friend",
    desc: "Browse our available golden retriever puppies.",
    cta: { text: "See Puppies", link: "/puppies" }
  },
  {
    icon: <FaHandHoldingUsd />,
    title: "Reserve or Visit",
    desc: "Reach out to schedule a visit or place a deposit to reserve your puppy. Please note that puppies are not held without a deposit.",
    cta: { text: "Contact Us", link: "/contact" } // changed here
  },
  {
    icon: <FaCalendarCheck />,
    title: "Meet Your Puppy",
    desc: "Come meet in person or virtually.",
    cta: null
  },
  {
    icon: <FaHome />,
    title: "Welcome Home",
    desc: "Pick up your puppy with records, a starter kit, and our support.",
    cta: null
  }
];


// TimelineSection.js
export default function TimelineSection() {
  return (
    <section className="hiw-horizontal">
      <div className="hiw-card">
        <h2 className="hiw-h-title">How It Works</h2>
        <p className="hiw-h-subtitle">
          Your journey to a golden retriever, step by step.
        </p>
        <div className="hiw-h-steps">
          {steps.map((step, i) => (
            <motion.div
              className="hiw-h-step"
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: i * 0.07 }}
              viewport={{ once: true }}
            >
              <div className="hiw-h-icon">{step.icon}</div>
              <div className="hiw-h-circle">{i + 1}</div>
              <h3 className="hiw-h-step-title">{step.title}</h3>
              <p className="hiw-h-step-desc">{step.desc}</p>
              {step.cta && (
                <Link to={step.cta.link} className="hiw-h-btn">
                  {step.cta.text}
                </Link>
              )}
              {i < steps.length - 1 && <div className="hiw-h-line"></div>}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
